import { TourConfig } from "@/types/tour"
import { standardOffset } from "./utils/floatingUIConfigs"
import WelcomeStep from "./steps/rewards_tour/WelcomeStep.vue"
import RegExStep from "./steps/rewards_tour/RegExStep.vue"
import { componentAsHtml } from "./utils/componentAsHtml"

export const rewardsTour: TourConfig = {
   id: "rewards_tour",
   humanReadableName: "Rewards Tour",
   skippable: true,
   options: {
      useModalOverlay: true,
      defaultStepOptions: {
         classes: "q-card q-dark-transition shepherd-theme-quasar",
         arrow: true,
         scrollTo: { behavior: "smooth", block: "center" },
      },
   },
   steps: [
      {
         id: "welcome",
         title: "Learn about Page View Rewards",
         text: componentAsHtml(WelcomeStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
      },
      {
         id: "rewards-form",
         text: "This form allows you to configure a page view event as a reward metric for your project.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "#rewards-edit-form",
            on: "top",
         },
         floatingUIOptions: standardOffset,
      },
      {
         id: "url-pattern-step",
         text: componentAsHtml(RegExStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: ".q-input",
            on: "bottom",
         },
         floatingUIOptions: standardOffset,
      },
      {
         id: "tour-complete",
         text: "You've completed the Rewards page tour! You can now configure your Page View Reward to optimize your site's performance.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  if (this.complete) return this.complete()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Complete",
            },
         ],
         floatingUIOptions: standardOffset,
      },
   ],
}
